import { OrderBoard } from '../components/OrderBoard';

export function BarPage() {
  return <OrderBoard station="bar" titleKey="bar.title" />;
}
